<template>
  <div>
    <div class="user-info">
      <div class="user-info-content mb48">
        <div class="user-info-item">
          <div class="title f24 mb16">{{ $t('phone') }}</div>
          <div class="content f28">{{ userInfo.mobile }}</div>
        </div>
        <div class="user-info-item">
          <div class="title f24 mb16">{{ $t('flashPayAccount') }}</div>
          <div class="content f28">{{ userInfo.account }}</div>
        </div>
      </div>
      <!-- <div class="user-info-content">
        <div class="user-info-item">
          <div class="title f24 mb16">{{ $t('email') }}</div>
          <div class="content f28">{{ userInfo.email }}</div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserInfo',
  data () {
    return {
      userInfo: {}
    }
  },
  created () {},
  mounted () {
    this.userInfo = this.$store.getters.accountInfo
  },
  methods: {}
}
</script>

<style lang='scss' scoped>
.user-info {
  padding: 40px 48px;
  border-top: 2px dashed #f0f0f0;
}

.user-info-content {
  display: flex;

  .user-info-item {
    flex: 2;
  }

  .title {
    color: #b2b2b2;
  }
}
</style>
